import request from '@/utils/request';

/**
 * 用户登录
 * @param { code: 微信code } data
 */
export function WXlogin(data) {
  return request({
    url: '/wx-login',
    method: 'post',
    data
  });
}

/**
 * 退出登录
 * @param {*} data
 */
export function logout(data) {
  return request({
    url: '/logout',
    method: 'post',
    data
  });
}
/**
 * 获取用户信息
 * @param {*} data
 */
export function getUserInfo(data) {
  return request({
    url: '/info',
    method: 'post',
    data
  });
}

/**
 * 获取员工列表
 * @param { page, count } data
 */
export function getStaffList(data) {
  return request({
    url: 'staff/list',
    method: 'post',
    data
  });
}

/**
 * 获取账号列表
 */
export function getUmList(data) {
  return request({
    url: '/list-all',
    method: 'post',
    data
  });
}
